"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var VIcon_vue_1 = __importDefault(require("../scraps/VIcon.vue"));
var DropdownSelect_vue_1 = __importDefault(require("../form/DropdownSelect.vue"));
var event_bus_1 = require("../../event-bus");
exports.default = vue_1.default.extend({
    name: "role-select",
    components: {
        DropdownSelect: DropdownSelect_vue_1.default,
        VIcon: VIcon_vue_1.default
    },
    props: {
        currentRole: {
            type: Object,
            required: true
        },
        roles: {
            type: Array,
            required: true
        }
    },
    methods: {
        getCurrentOption: function () {
            return {
                value: this.currentRole.id,
                name: this.currentRole.name
            };
        },
        onChange: function (option) {
            this.$emit("change", {
                id: option.value,
                name: option.name
            });
            event_bus_1.EventBus.$emit(event_bus_1.events.role.select, {
                id: option.value,
                name: option.name
            });
        }
    }
});
